// extracted by mini-css-extract-plugin
export default {"total":"Files_total__eTG+G","actions":"Files_actions__-rvCt"};